import { useContext } from "react";
import { EnquiryFormContext } from "./EnquiryForm";
export var useEnquireForm = function useEnquireForm() {
  return useContext(EnquiryFormContext);
};
export default useEnquireForm;